import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import './NotFound.css';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <Container className="notfound-container" maxWidth="md">
      <Box className="notfound-box">
        <Typography variant="h1" className="notfound-code">
          404
        </Typography>
        <Typography variant="h4" className="notfound-title" gutterBottom>
          Page Not Found
        </Typography>
        <Typography variant="body1" className="notfound-message">
          Sorry, the page you are looking for does not exist or has been moved.
        </Typography>

        <img src="/404.jpg" alt="Not Found" className="notfound-image" />

        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate('/')}
          className="notfound-button"
        >
          Go to Homepage
        </Button>
      </Box>
    </Container>
  );
}
